import { useContext } from 'react';
import { BrowserWidthContext } from 'providers/BrowserWidthProvider';

const useBrowserWidth = () => useContext(BrowserWidthContext);

export default useBrowserWidth;
